import { render, staticRenderFns } from "./swiperImagePreviewer.vue?vue&type=template&id=3800e044&scoped=true"
import script from "./swiperImagePreviewer.vue?vue&type=script&lang=js"
export * from "./swiperImagePreviewer.vue?vue&type=script&lang=js"
import style0 from "./swiperImagePreviewer.vue?vue&type=style&index=0&id=3800e044&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800e044",
  null
  
)

export default component.exports